<template>
  <base-sheet :visible="visible" @close="$emit('close')">
    <p v-if="group" class="vxl-sheet__label">{{ group.name }}</p>

    <button class="vxl-sheet__row vxl-sheet__row--danger" @click="onAction('remove-all')">
      <i class="material-icons vxl-sheet__row-icon">delete_outline</i>
      <span>Remover todos os downloads</span>
    </button>

    <button class="vxl-sheet__action vxl-sheet__action--ghost" @click="$emit('close')">
      Cancelar
    </button>
  </base-sheet>
</template>

<script>
import BaseSheet from '@/components/base/BaseSheet';

export default {
  name: 'GroupActionsSheet',
  components: { BaseSheet },
  props: {
    visible: { type: Boolean, default: false },
    group: { type: Object, default: null }
  },
  methods: {
    onAction (name) {
      if (!this.group) return;
      this.$emit(name, { enrollId: this.group.enrollId, name: this.group.name, loIds: this.group.loIds });
      this.$emit('close');
    }
  }
};
</script>
